import React from 'react'
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//Import Scss
import "./style.scss";
//Import assets
import assets from "../../../Assets"

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from 'Components/Common/DatePicker';
import DropDownBox from "Components/Common/DropDownBox";

//Import NPM Components
import "react-datepicker/dist/react-datepicker.css";

//redux
import { useDispatch } from "react-redux";
import { closeConditionMonitoringRequest, fetchConditionMonitoringReqList } from "../../../Redux/Slices/requestManagementSlice";
import { fetchUserManagementCompany } from '../../../Redux/Slices/userManagementSlice';


const ConditionMonitoringRequest = () => {
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
      singleClickFunc: () => { },
    },
    {
      label: "Users Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "user_name" })
      },
    },
    {
      label: "Mobile Number",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "mobile_number" })
      },
    },
    {
      label: "Company Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "company_name" })
      },
    },
    // {
    //   label: "User Type",
    //   sortKey: false,   
    // },
    {
      label: "Request Submitted on",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "request_submitted_on" })
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "is_closed" })
      },
    },
    {
      label: "Action",
      sortKey: false,
    },
  ];

  const [company, setCompany] = useState(null);

  const [companyList, setCompanyList] = useState([]);

  // const handleChange = (selectedOption) => {
  //   setSelectedOption(selectedOption);
  // };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [callReqList, setCallReqList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [handleRerender, setHandleRerender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFromDate = (date) => {
    // if (date) {
    //   setFromDate(new Date(date));
    // } else {
    //   setFromDate(null); 
    // }
    setFromDate(date ? new Date(date) : null)
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
  };
  const handleToDate = (date) => {
    setToDate(date ? new Date(date) : null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    // Extract hours and minutes
    // let hours = date.getHours();
    // const minutes = String(date.getMinutes()).padStart(2, '0');

    // Determine AM/PM and format hours
    // const ampm = hours >= 12 ? 'PM' : 'AM';
    // hours = hours % 12 || 12;

    // Format the date and time
    return `${day}/${month}/${year} `;
  }

  function formatSendDate(dateString) {
    if (dateString === "") {
      return ""
    }
    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;

    // Prevent sending "1970-01-01"
    return formattedDate === "1970-01-01" ? null : formattedDate;
  }

  const getInitials = (name) => {
    const [firstName = "", lastName = ""] = name.split(" ");
    return (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase();
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  const closeRequest = (id) => {
    dispatch(
      closeConditionMonitoringRequest({
        data: {
          id
        },
        callBack: (value) => {
          console.log(value)
          setHandleRerender(!handleRerender)
          setOpenMenuId(null)
        }
      })
    )
  }

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  useEffect(() => {
    setIsLoading(true)
    dispatch(
      fetchUserManagementCompany({
        callBack: (value) => {
          // console.log(value.data)
          //add laabel and value for dropdown options
          const updatedCategories = value.data.map(item => ({
            ...item,
            label: item.company_name,
            value: item.company_id
          }));
          const additionalObject = {
            label: 'All Companies',
            value: '',
            company_name: 'All Companies'
          };
          setCompanyList([additionalObject, ...updatedCategories])
        },
      })
    )
    dispatch(
      fetchConditionMonitoringReqList({
        data: {
          page: currentPage,
          limit: "10",
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
          fromDate: formatSendDate(fromDate) || "",
          toDate: formatSendDate(toDate) || "",
          ...(formatSendDate(toDate) && { toDate: formatSendDate(toDate) }),
          company_id: company?.company_id || "",
        },
        callBack: (value) => {
          console.log(value)
          setCallReqList(value.data.data_list || value.data)
          setTotalPages(value.data.pageMeta.totalPages || 1)
          setTotalCount(value?.data?.pageMeta?.total || 0);
          setIsLoading(false)
        },
      })
    );
  }, [sortOptions, currentPage, company, fromDate, toDate, handleRerender])

  return (
    <div className="callRequestContainer">
      <div className="callRequestHeader">
        <p className='totalCount'>Condition Monitoring Request</p>
        <div className="callReqDatePicker">
          <p className="totalCount">
  Total count : {totalCount}
</p>
          <DropDownBox
            options={companyList}
            placeholder="Company Name"
            onChange={(option) => {
              setCompany(option);
              setCurrentPage(1);
            }}
            value={company}
            customStyles={{
              control: (provided) => ({
                ...provided,
                border: '0px',
                borderBottom: '1px solid grey',
                borderRadius: '0',
                width: '180px',
                boxShadow: 'none',
                padding: '5px 3px',
                fontFamily: 'Poppins',
                marginRight: '20px',
                fontSize: '14px',
                height: "50px",
              }),
              menu: (provided) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
              }),
              option: (provided, state) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
                backgroundColor: state.isFocused ? '#f1f1f1' : 'white',
                color: state.isFocused ? 'black' : 'grey',
                cursor: 'pointer',
              }),
            }}
          />
          <DatePicker
            placeholderText="From Date"
            selected={fromDate}
            onChange={handleFromDate}
            format={"dd-MM-yyyy"}
          />
          <DatePicker
            placeholderText="To Date"
            selected={toDate}
            minDate={fromDate}
            onChange={handleToDate}
            format={"dd-MM-yyyy"}
          />
        </div>
      </div>
      <div className="callReqTableContainer">
        <NormalTable
          headerDetails={headerDetails}
        // pagination={true}
        >{callReqList.length > 0
          ? callReqList.map((list, index) => {
            return (
              <>
                <tr
                  className="border"
                  key={list.condition_monitoring_request_id}
                  style={{ position: "relative" }}
                >
                  <td style={{
                    paddingLeft: "18px",
                  }}>{(currentPage - 1) * 10 + (index + 1)}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "3px",
                        alignItems: "center",
                      }}
                    >
                      {list.user_name ? (
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            backgroundColor: "#1E2156",
                            borderRadius: "50%",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {getInitials(list.user_name)}
                        </div>
                      ) : (
                        ""
                      )}
                      <p>{list.user_name}</p>
                    </div>
                  </td>
                  <td>{list?.country_code}&nbsp;{list.mobile_number}</td>
                  <td>{list.company_name}</td>
                  {/* <td>{list.pay?'Paid':'Free'}</td> */}
                  <td>{formatDate(list.createdAt)}</td>
                  {/* <td>{list?.message.length > 25 ? `${list?.message.slice(0,25)}...`
                            :list?.message}
                        </td> */}
                  <td
                    style={{
                      color: `${list.is_closed ? "#10CA23" : "#FF482F"}`,
                    }}
                  >
                    {list.is_closed ? "Closed" : "Open"}
                  </td>
                  <td>
                    <img
                      style={{ height: "15px", cursor: "pointer" }}
                      src={assets.Icons.optionsIcon}
                      alt="Options"
                      onClick={() =>
                        toggleMenu(list.condition_monitoring_request_id)
                      }
                    />
                    {openMenuId ===
                      list.condition_monitoring_request_id && (
                        <div className="optionsMenu">
                          <ul>
                            <li
                              onClick={() =>
                                navigate(
                                  `/request/conditionMonitoringRequestDetails/${list.condition_monitoring_request_id}`
                                )
                              }
                            >
                              <img src={assets.Icons.viewIcon} alt="" />
                              View
                            </li>
                            {!list.is_closed ? <li onClick={() => closeRequest(list.condition_monitoring_request_id)}>
                              <p
                                style={{
                                  color: "lightgray",
                                  fontWeight: "700",
                                  fontSize: "18px",
                                  marginRight: "10px",
                                  marginLeft: "5px",
                                }}
                              >
                                X
                              </p>
                              Close
                            </li> : ""}
                          </ul>
                        </div>
                      )}
                    {/* <button
                            onClick={() =>
                              navigate(`/request/callRequestDetails/${list.engineering_counsultaion_request_id}`)
                            }
                            className="callRequestViewButton"
                          >
                            View Details
                          </button> */}
                  </td>
                </tr>
              </>
            );
          })
          : ""}
        </NormalTable>
        {callReqList.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh" }}> {isLoading ? "Loading" : "No Data Found"} </p>}
        {callReqList.length > 0 ?
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          /> : ""}
      </div>
    </div>
  );
}

export default ConditionMonitoringRequest